import { Dropdown as UiDropdown } from "simplydo/react/ui/dropdown";

import { FieldProps, getStringFieldOptions } from "./FieldProps";

const Dropdown = ({
  field,
  fieldValue = "",
  updateIdea,
  isEditing,
  assessmentIsClosed,
  isAssessment,
}: FieldProps) => {
  if (!isEditing) return <span>{String(fieldValue ?? "")}</span>;
  return (
    <UiDropdown
      placeholder="Options"
      clearable
      variant="outline"
      value={fieldValue as string}
      onChange={(_e, { value }) =>
        updateIdea(value ?? null, ["templated", field.id])
      }
      options={getStringFieldOptions(field.options).map((option, i) => ({
        key: i,
        value: option,
        text: option,
      }))}
      disabled={isAssessment && assessmentIsClosed}
    />
  );
};

export default Dropdown;
